import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import { memo, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  checkListConfig,
  SimilarTitlesAndParagraphTitles,
  SimilarTitlesAndParagraphUrls
} from '../../config/checkListConfig';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  useGetInfoMutation,
  useGetSimilarTitlesByGroupIdMutation,
  useGetSimilarParagraphsByGroupIdMutation
} from '@/app/Crawl/api/checklistsApi';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import { useExportTableMutation } from '@/app/Crawl/api/exportApi';
import useDomain from '@/hooks/useDomain';
import type { FilterColumn } from '@/app/common/components/filters/filterTypes';

interface CheckListGridProps {
  path?: string;
  crawl_status?: number | null;
}

const CheckListGrid = memo(
  ({ path, crawl_status }: CheckListGridProps): React.JSX.Element => {
  let columns: FilterColumn[] = [];
  const { domain_slug } = useDomain();
  const { slug } = useParams();
  const [getInfo] = useGetInfoMutation();
  const [searchParams] = useSearchParams();
  const [exportTable] = useExportTableMutation();

  // دریافت پارامتر issues از url و بررسی اینکه کدام ستون ها به جدول داده شود
  if (
    checkListConfig(crawl_status).errors.find(
      item => searchParams.get('issues') === item.link
    )
  ) {
    columns =
      checkListConfig(crawl_status).errors.find(
      item => searchParams.get('issues') === item.link
      )?.columns ?? [];
  } else if (
    checkListConfig(crawl_status).warning.find(
      item => searchParams.get('issues') === item.link
    )
  ) {
    columns =
      checkListConfig(crawl_status).warning.find(
      item => searchParams.get('issues') === item.link
      )?.columns ?? [];
  } else if (
    checkListConfig(crawl_status).info.find(
      item => searchParams.get('issues') === item.link
    )
  ) {
    columns =
      checkListConfig(crawl_status).info.find(
      item => searchParams.get('issues') === item.link
      )?.columns ?? [];
  }

  const [getSimilarTitles] = useGetSimilarTitlesByGroupIdMutation();
  const [getSimilarParagraph] = useGetSimilarParagraphsByGroupIdMutation();

  return (
    <Row className="my-3">
      <Col xxl={12}>
        {/* فیلتر های جدول */}
        <FiltersComponent
          columns={columns}
          preQueries={`issues=${searchParams.get('issues')}`}
        />
      </Col>
      <Col>
        {/* جدول فهرست بازبینی */}
        <AgGridWrapper
          table_name={`${location.pathname
            .split('/')
            .slice(1, 3)
            .join('/')}/${searchParams.get('issues')}`}
          additionalData={{
            job_page: slug === 'last' ? domain_slug : slug,
            domain_slug,
            filter_type: searchParams.get('issues')
          }}
          fetchFunction={getInfo}
          height="756px"
          settings={{
            pagination: true,
            export: {
              enabled: true,
              fetchFunction: exportTable
            },
            // نمایش جدول زیرین برای پاراگراف های مشابه
            masterDetail:
              searchParams.get('issues') === 'similar_paragraphs'
                ? [
                    {
                      fetchFunction: getSimilarParagraph,
                      additionalData: {
                        job_page: slug === 'last' ? domain_slug : slug,
                        domain_slug,
                        type: 'url'
                      },
                      path,
                      columns: SimilarTitlesAndParagraphUrls,
                      targetParam: 'group_id'
                    },
                    {
                      fetchFunction: getSimilarParagraph,
                      additionalData: {
                        job_page: slug === 'last' ? domain_slug : slug,
                        domain_slug,
                        type: 'content'
                      },
                      path,
                      columns: SimilarTitlesAndParagraphTitles,
                      targetParam: 'group_id'
                    }
                  ]
                : [
                    {
                      fetchFunction: getSimilarTitles,
                      additionalData: {
                        job_page: slug === 'last' ? domain_slug : slug,
                        domain_slug,
                        type: 'url'
                      },
                      path,
                      columns: SimilarTitlesAndParagraphUrls,
                      targetParam: 'group_id'
                    },
                    {
                      fetchFunction: getSimilarTitles,
                      additionalData: {
                        job_page: slug === 'last' ? domain_slug : slug,
                        domain_slug,
                        type: 'content'
                      },
                      path,
                      columns: SimilarTitlesAndParagraphTitles,
                      targetParam: 'group_id'
                    }
                  ]
          }}
          columns={useMemo(
            () => columns,
            [searchParams.get('issues'), domain_slug, slug]
          )}
        />
      </Col>
    </Row>
  );
  }
);

export default CheckListGrid;
